import { render } from "./dataScreen.vue?vue&type=template&id=74966578&scoped=true"
import script from "./dataScreen.vue?vue&type=script&lang=js"
export * from "./dataScreen.vue?vue&type=script&lang=js"

import "./dataScreen.vue?vue&type=style&index=0&id=74966578&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74966578"],['__file',"src/views/data/components/dataScreen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74966578"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74966578', __exports__)) {
    console.log('reload')
    api.reload('74966578', __exports__)
  }
  
  module.hot.accept("./dataScreen.vue?vue&type=template&id=74966578&scoped=true", () => {
    console.log('re-render')
    api.rerender('74966578', render)
  })

}


export default __exports__